export class AdminIdeasOpinionsCommentsDeleteRequest {
  ideaId!:string
  opinionId!:string
  opinionCommentId!:string
}
